import { useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import {
  AdminOrderItem,
  FrontendActionEventData,
  UseSocketHookReturn,
} from '../interface/interface';

export function useSocket(token: string): UseSocketHookReturn {
  const [isSocketConnected, setConnectionStatus] = useState<boolean>(false);
  const [newOrders, setNewOrders] = useState<Array<AdminOrderItem>>([]);
  const [refreshCounter, setRefreshCounter] = useState<number>(0);
  const [refreshTokens, setRefreshTokens] = useState<number>(0);
  const [refreshProducts, setRefreshProducts] = useState<number>(0);

  function onConnect() {
    console.log('Connected to Socket');
    setConnectionStatus(true);
  }

  function onDisconnect() {
    setConnectionStatus(false);
  }

  function onOrders(data: Array<AdminOrderItem>) {
    setNewOrders(data);
  }

  function onFrontendActions(data: FrontendActionEventData) {
    if (data.action === 'REFRESH_ORDERS') setRefreshCounter((p) => p + 1);
    if (data.action === 'REFRESH_TOKENS') setRefreshTokens((prev) => prev + 1);
    if (data.action === 'REFRESH_PRODUCTS')
      setRefreshProducts((prev) => prev + 1);
  }

  /**
   * The connection will be disconnected from the
   * service when there is a notable amount of idle time.
   *
   * This hook can reconnect whenever the connection got disconnected.
   */
  useEffect(() => {
    // Ignore if already Connected!
    if (isSocketConnected) return;

    const sockClient = io(process.env.VITE_API_URL ?? '', {
      extraHeaders: { authorization: `Bearer ${token}` },
    });

    sockClient.on('connect', onConnect);
    sockClient.on('disconnect', onDisconnect);
    sockClient.on('orders', onOrders);
    sockClient.on('frontendActions', onFrontendActions);
  }, [isSocketConnected]);

  return [
    newOrders,
    isSocketConnected,
    refreshCounter,
    refreshTokens,
    refreshProducts,
  ];
}
